import ReadyStartSection from './Component';

export default ReadyStartSection;